import React from 'react';
import IconType from './iconType';

function FilledAddIcon({ color = '#7357E9', width = 21, height = 21 }: IconType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21 21" fill="none">
      <rect x="0.5" y="0.320312" width="20" height="20" rx="10" fill={color} />
      <path d="M10.5 13.6432V6.97656" stroke="white" strokeWidth="0.96506" strokeLinecap="round" />
      <path d="M7.16797 10.3125H13.8346" stroke="white" strokeWidth="0.96506" strokeLinecap="round" />
    </svg>
  );
}

export default FilledAddIcon;
